import React from 'react';

const Stat = ({ value, label }) => (
  <div>
    <p className="text-navy text-lg font-medium">{value}</p>
    <p className="text-slate text-[10px]">{label}</p>
  </div>
);

export default Stat;
